import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { FiltroBuscaService } from '../service/filtro-busca-service/filtro-busca.service';

@Component({
  selector: 'app-filtro-cronograma',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-cronograma.component.html',
  styleUrl: './filtro-cronograma.component.scss',
})
export class FiltroCronogramaComponent {
  @Input() bloqueandoAtualizacao: boolean = false;
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  filtroCronograma: Array<any> = [];
  selecionado: any = null;

  @Input() idModuloSelecionado: number;
  @Input() cronogramaSelecionados: any[] = [];
  @Output() cronogramaChange = new EventEmitter<any>();
  @Input() cronogramaSelecionado: any = null;
  @Input() disabled: boolean = false;

  private readonly _errorHandleService = inject(ErrorHandleService);
  private subscription = new Subscription();
  private jaCarregou = false;

  constructor(private readonly _filtroBuscaService: FiltroBuscaService) {}

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (this.idModuloSelecionado === 234 || this.bloqueandoAtualizacao) {
      return;
    }
    if (changes.idModuloSelecionado || !this.jaCarregou) {
      this.jaCarregou = true;
      this.cronogramaObra();
    }
    if (changes.cronogramaSelecionados && this.filtroCronograma.length > 0) {
      this.sincronizarCronogramaSelecionados();
    }
  }

  sincronizarCronogramaSelecionados() {
    if (!Array.isArray(this.cronogramaSelecionados)) return;
    const selecionadosIds = this.cronogramaSelecionados.map((c) => c.id);
    this.filtroCronograma.forEach((item) => {
      item.checked = selecionadosIds.includes(item.id);
    });
  }

  onCronogramaChange() {
    const selecionados = this.filtroCronograma.filter((o) => o['checked']);
    this.cronogramaChange.emit(selecionados);
  }

  cronogramaObra() {
    this.subscription.add(
      this._filtroBuscaService
        .filtroCronograma(this.idModuloSelecionado)
        .subscribe({
          next: (res) => {
            if (res.success) {
              this.filtroCronograma = res.data;
              this.sincronizarCronogramaSelecionados();
              this._errorHandleService.throwConsoleError(res.message);
            }
          },
          error: (err) => {
            console.error('Erro na API:', err);
            this._errorHandleService.throwConsoleError(
              'Erro ao buscar cronograma.'
            );
          },
        })
    );
  }
}
